import Auth from '@Services/Auth';
import { createSelector } from 'reselect';
import get from 'lodash/get';
import { registerReducerKey } from './RegisterConstants';

export function register(state) {
  return state.get(registerReducerKey);
}

export function ipAddress(state) {
  return register(state).get('ipAddress');
}

export function isLoading(state) {
  return register(state).get('isLoading');
}

export function data(state) {
  return register(state).get('data');
}

export function registerFail(state) {
  return register(state).get('registerFail');
}

export function isAnonymousUser() {
  return Auth && Auth.isAnonymousUser();
}

// eslint-disable-next-line no-shadow
export const isShibboleth = createSelector([data], (data) => {
  return get(data, 'registrationType') === 'SHIBBOLETH';
});
